'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import styles from './SampleTopCloseButton.module.scss';
type SampleTopCloseButtonProps = {
  onClick: () => void;
  label?: string;
};
export function SampleTopCloseButton(t0) {
  const $ = _c(4);
  const {
    onClick,
    label: t1
  } = t0;
  const label = t1 === undefined ? "Close" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Image src="/intro/sample_close_button.svg" alt="" width={44} height={44} className={styles.icon} />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== label || $[2] !== onClick) {
    t3 = <button type="button" onClick={onClick} aria-label={label} className={styles.button}>{t2}</button>;
    $[1] = label;
    $[2] = onClick;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}